
import Vue from "vue";
import { mapFields } from "vuex-map-fields";

export default Vue.extend({
    name: "UppladdadeFilerSammanstallning",
    computed: {
        ...mapFields(["observationer.files"]),
    },
});
